import { render, staticRenderFns } from "./el-tabs.vue?vue&type=template&id=e79be902"
import script from "./el-tabs.vue?vue&type=script&lang=js"
export * from "./el-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports